module.exports = __webpack_public_path__ + "static/media/modalSair.2586d67d.jpg";